<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0001 20C7.87007 20 4.16007 17.16 2.09007 12.4C1.98007 12.15 1.98007 11.86 2.09007 11.6C4.16007 6.84 7.87007 4 12.0001 4C16.1301 4 19.8401 6.84 21.9201 11.6C22.0301 11.85 22.0301 12.14 21.9201 12.4C19.8401 17.16 16.1401 20 12.0101 20H12.0001ZM4.10007 12C5.87007 15.77 8.80007 18 12.0001 18C15.2001 18 18.1301 15.77 19.9001 12C18.1301 8.23 15.2001 6 12.0001 6C8.80007 6 5.87007 8.23 4.10007 12ZM12.0001 16.04C9.75007 16.04 7.92007 14.23 7.92007 12.01C7.92007 9.79 9.75007 7.98 12.0001 7.98C14.2501 7.98 16.0801 9.79 16.0801 12.01C16.0801 14.23 14.2501 16.04 12.0001 16.04ZM12.0001 9.97C10.8501 9.97 9.92007 10.88 9.92007 12C9.92007 13.12 10.8501 14.03 12.0001 14.03C13.1501 14.03 14.0801 13.12 14.0801 12C14.0801 10.88 13.1501 9.97 12.0001 9.97Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
